import { NgModule } from '@angular/core';
import { ViewportService } from './services/viewport.service';
import { AllowNotificationsModalComponent } from '@app/integrations/semrush/components/allow-notifications-modal/allow-notifications-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    providers: [ViewportService],
    imports: [MatDialogModule, MatButtonModule],
    declarations: [AllowNotificationsModalComponent],
})
export class IntegrationSemrushModule {}
